{
  "pagination": {
    "showing": "Mostrando",
    "to": "a",
    "of": "de",
    "results": "resultados",
    "previous": "Anterior",
    "next": "Siguiente"
  },
  "copyRight": "2022 Todos los derechos reservados",
  "generic": {
    "back": "Regresar"
  },
  "header": {
    "viewCompany": "Ver empresa",
    "viewProfile": "Ver perfil",
    "signOut": "Cerrar sesión"
  },
  "buttons": {
    "Continue": "Continuar",
    "Done": "¡Listo!",
    "Delete": "Borrar",
    "Cancel": "Cancelar",
    "Add": "Agregar",
    "Update": "Actualizar",
    "Save": "Ahorrar",
    "Saving": "Guardando",
    "Previous": "Anterior",
    "Add facility": "Agregar instalación",
    "surveySave": "Guardar",
    "next": "Siguiente",
    "EXPORT_DATA": "Exportar datos"
  },
  "errors": {
    "required": "is a required field",
    "Attention": "¡Atención!"
  },
  "months": {
    "1":  "Enero",
    "2": "Febrero",
    "3": "Marzo",
    "4": "Abril",
    "5": "Mayo",
    "6": "Junio",
    "7": "Julio",
    "8": "Agosto",
    "9": "Septiembre",
    "10": "Octubre",
    "11": "Noviembre",
    "12": "Diciembre"
  },
  "nav": {
    "Dashboard": "Resumen",
    "Calculation": "Cálculo",
    "Analysis": "Análisis",
    "Goals": "Objetivos",
    "Comparison": "Comparador",
    "Reports": "Reportes",
    "viewProfile": "Ver cuenta",
    "signOut": "Desconectar",
    "Decarbonization": "Descarbonización",
    "DataHub": "Centro de Datos",
    "DataEntry": "Entrada de Datos",
    "FormBuilder": "Constructor de Formularios",
    "DataExplorer": "Explorador de Datos",
    "SavedQueries": "Consultas Guardadas",
    "DataReport": "Reporte de Datos"
  },
  "dataHub": {
    "title": "Centro de Datos", 
    "subtitle": "Sistema centralizado de gestión y entrada de datos",
    "dataEntry": "Entrada de Datos",
    "dataEntryDesc": "Crear y gestionar envíos de formularios usando formularios dinámicos",
    "dataManagement": "Gestión de Datos",
    "dataIntegration": "Integración de Datos",
    "comingSoon": "Próximamente...",
    "inputForms": "Formularios de Entrada",
    "inputFormsDesc": "Crear y gestionar envíos de formularios usando formularios dinámicos"
  },
  "login": {
    "welcome": "¡Bienvenido!",
    "subText": "Ingresa los datos de acceso que recibiste por correo electrónico",
    "username": "Correo electrónico",
    "password": "Contraseña",
    "login": "Ingresar",
    "forgotPasswordHelpText": "¿Tienes problemas para ingresar?",
    "contactUs": "Contáctanos",
    "inValidLogin": "Usuario o contraseña incorrecta",
    "emailIsRequired": "el correo electrónico es un campo obligatorio",
    "inValidEmail": "el correo electrónico debe ser un correo electrónico válido",
    "passwordIsRequired": "La contraseña es un campo requerido"
  },
  "forgotPassword": {
    "forgotPassword": "Olvidé mi contraseña",
    "backToLogin": "Regresar al login",
    "forgotPasswordExplanation": "Ingresa el correo asociado a la cuenta y te enviaremos un link para actualizarla",
    "forgotSuccessTitle": "El link para cambiar tu contraseña ha sido enviado a tu correo",
    "forgotAttention": "Si no haz recibido el correo para cambiar tu contraseña:",
    "forgotWarning1": "Revisa el buzón de Spam",
    "forgotWarning2": "Revisa que el correo ingresado sea correcto",
    "sendEmail": "Enviar Email",
    "changePassword": "Cambiar contraseña",
    "changePasswordExplanation": "Tu contraseña deberá de ser de al menos 8 caracteres y contener letras y números.",
    "changeError": "Código de activación inválido o token expirado",
    "changeSuccessMsg": "Tu contraseña ha sido actualizada",
    "resetMyPassword": "Restablecer mi contraseña"
  },
  "placeHolder": {
    "threeCharacters": "Escribe al menos 3 caracteres"
  },
  "welcome": {
    "thankYouText": "¡Muchas gracias por dar los primeros pasos para descarbonizar tu empresa!",
    "description": "Por ser la primera vez que estás aquí, vamos a pedirte que respondas unas preguntas para personalizar tu plataforma.",
    "button": "Iniciar"
  },
  "personal": {
    "pageTitle": "Compártenos tu información personal",
    "firstName": "Nombre(s)",
    "lastName": "Apellido(s)",
    "title": "Rol en la empresa",
    "createPassword": "Configura tu nueva contraseña\nde ingreso",
    "newPassword": "Nueva contraseña",
    "confirmPassword": "Confirmar nueva contraseña",
    "noMatch": "Las contraseñas deben coincidir",
    "userTitle": "Rol"
  },
  "companySetting": {
    "pageTitle": "Es un placer conocerte, {name}",
    "description": "Tell us about your company",
    "companyName": "Nombre de la empresa",
    "sector": "Sector",
    "subSector": "Sub sector",
    "helpText": "Si no encuentras el tuyo, selecciona “Otro”",
    "sectors": "Conoce más de los Sectores",
    "infoText": "Un sector es un conjunto de actividades económicas creadas de acuerdo con la esencia de las tareas o actividades que realiza tu empresa. Dentro de un sector existen otras ramificaciones llamadas sub-sector, creadas para especificar con mayor detalle la actividad que desarrollas en tu empresa.",
    "intensityUnit": "Unidad de producción"
  },
  "operationInfo": {
    "title": "El siguiente paso es entrar a los detalles de tus operaciones",
    "p1": "La huella de carbono se calcula por cada instalación que tengan, ya sea una oficina, centro de distribución, fábrica o cualquier otro tipo de instalación.",
    "p2": "Ahora nos ayudarás a definir los tipos de instalaciones que tienen en su operación, y detalles particulares de cada uno."
  },
  "facility": {
    "title": "¿Qué tipo de instalaciones hay en tu empresa?",
    "description": "Selecciona una o más",
    "otherFacilityType": "Otra instalación",
    "infoTitle": "Conoce más de las instalaciones",
    "infoText": "Una instalaciones es la ubicación donde desarrolla tu empresa su actividad. Podrías tener una o más con diferentes fines, acá te platicamos más: Por ejemplo: GRUPO AÑIL es una empresa que desarrolla materiales para construcción y tiene 3 instalaciones, la primera es una fábrica, la segunda es un punto de venta y la tercera es un laboratorio.",
    "otherFacilityPlaceOlder": "Tipo de instalación",
    "showAll": "Mostrar todo",
    "showLess": "Mostrar menos",
    "allFacilities": "Todas las instalaciones",
    "detail": {
      "title": "Ahora, entremos al detalle",
      "description": "Compártenos más detalle de cada instalación",
      "uploadButtonText": "Subir mi propia lista",
      "header": {
        "facility": "Instalación",
        "name": "Define un nombre",
        "nameToolTipDesc": "Será el nombre con el cual identificaremos esta instalación a lo largo de toda la plataforma, te recomendamos utilizar el nombre que usan internamente en la compañía.",
        "location": "Agrega la ubicación",
        "locationToolTipDesc": "Agrega la ubicación de la instalación a través de Google Maps.",
        "tags": "Etiqueta",
        "tagToolTipDesc": "Las etiquetas son muy importantes, nos ayudarán a agrupar instalaciones y a hacer filtros más adelante. Si en tu compañía tiene, por ejemplo, “fabricas del noreste y las del sur”, asegúrate de de agregar esas etiquetas con las que identifican cada una. Nosotros hemos pre agregado algunas etiquetas geográficas, pueden editarlas o eliminarlas si desean."
      },
      "AddIntensity": "Agregar intensidades",
      "intensity": {
        "title": "Add intensity",
        "updateTitle": "Intensidad de actualización",
        "year": "Año",
        "employee": "Número de empleados",
        "income": "Ingresos anuales",
        "production": "Producción",
        "errorMessage": "Introduzca al menos un tipo de intensidad"
      },
      "form": {
        "name": "Nombre",
        "address": "Dirección",
        "search": "Buscar",
        "tags": "Etiquetas",
        "addTag": "Agregar etiqueta",
        "tagName": "Nombre de etiqueta",
        "countrySelected": "País",
        "city": "Ciudad",
        "saveTag": "Etiqueta Save"
      },
      "confirmDeleteFacility": "Se eliminará la instalación {name}, Haga clic en eliminar para confirmar?",
      "unnamedDeleteFacility": "Se eliminará la instalación. Haga clic en eliminar para confirmar?",
      "facilityTypeError": "Por favor revisa el formato. El nombre del sitio o el tipo de sitio no puede estar vacío o ser un nombre repetido",
      "deleteFacility": "Elimina Sitio",
      "facilityDetail": "Detalles del Sitio",
      "deleteModalTitle": "¡El sitio será eliminado! ¿Estás seguro?",
      "deleteModalText": "Después de esto, todos los registros de este sitio serán eliminados.",
      "deletedSuccessMessage": "El sitio ha sido eliminado.",
      "LOCATION": "Ubication",
      "TAGS": "Etiqueta"
    },
    "facilityCreated": "Instalación creada con éxito ",
    "loading": "Cargando tipos de instalaciones...",
    "saving": "Guardando tipos de instalaciones",
    "success": {
      "customTypeRemoved": "Tipo de instalación personalizado eliminado con éxito",
      "fileUploaded": "Archivo de instalaciones subido con éxito",
      "saved": "Tipos de instalaciones guardados con éxito"
    },
    "warning": {
      "facilityLimitReached": "Límite de instalaciones alcanzado. No se pueden agregar más tipos personalizados"
    },
    "validation": {
      "typeNameRequired": "El nombre del tipo de instalación es requerido",
      "typeNameMinLength": "El nombre del tipo de instalación debe tener al menos 3 caracteres",
      "typeNameMaxLength": "El nombre del tipo de instalación no puede exceder 100 caracteres",
      "typeNameInvalidChars": "El nombre del tipo de instalación no puede contener caracteres especiales: ? $ ' #",
      "typeNameDuplicate": "Este nombre de tipo de instalación ya existe",
      "typeNameNotEditable": "El nombre del tipo de instalación guardado no se puede cambiar",
      "atLeastOneFacility": "Se requiere al menos una instalación",
      "facilityLimitExceeded": "El total de instalaciones no puede exceder {limit}"
    },
    "error": {
      "decreaseCount": "Error al disminuir el conteo de instalaciones",
      "invalidName": "Nombre de instalación inválido",
      "removeCustomType": "Error al eliminar el tipo de instalación personalizado",
      "validationFailed": "Por favor corrija los errores de validación antes de enviar",
      "submit": "Error al guardar los tipos de instalaciones",
      "loadFailed": "Error al cargar los tipos de instalaciones",
      "saveFailed": "Error al guardar los tipos de instalaciones",
      "duplicateNames": "No se permiten nombres de tipos de instalaciones duplicados",
      "facilityLimitExceeded": "Se ha excedido el límite de instalaciones. No se pueden agregar más instalaciones.",
      "facilityTypeNotFound": "No se encontró el tipo de instalación especificado.",
      "facilityNameExists": "Ya existe una instalación con este nombre.",
      "createFailed": "Ocurrió un error inesperado al crear la instalación. Por favor, inténtelo de nuevo.",
      "createTitle": "Error al crear instalación"
    }

  },
  "emissionSetting": {
    "title": "¿Qué tipo de emisiones generas en tus {title}?",
    "selectAll": "Selecciona una o más",
    "modal": {
      "title": "Selecciona las emisiones de {title}",
      "selected": "seleccionadas",
      "facilityTypeName": {
        "offices": "oficinas",
        "plants": "fábricas",
        "factories": "fábricas",
        "shops": "tiendas",
        "Distribution Center": "centros de distribución",
        "Distribution": "centros de distribución"
      }
    }
  },
  "finish": {
    "title": "¡Terminamos!",
    "description": "Espera unos segundos, estamos preparando tu plataforma..."
  },
  "units": {
    "kg": "Kg",
    "tonne": "tonelada",
    "piece": "Pedazo",
    "m3": "m3",
    "m2": "m2",
    "percentage": "%",
    "meter": "Metro",
    "weight": "Peso",
    "km": "km"
  },
  "Facilities": "Instalaciones",
  "searchInputPlaceholder": "Buscar instalaciones o tags",
  "calculation": {
    "EMISSION_TYPE": "Tipo de emisión",
    "searchEmission": "Buscar emisión",
    "title": "Llena la información de tus emisiones",
    "addEmissionButton": "Agregar emisión",
    "addInfoButton": "Agregar info",
    "emission": "Emisión",
    "calculation": "Cálculo",
    "deleteAlert": "El registro será eliminado ¿Estás seguro?",
    "fileSelected": "1 archivo seleccionado | {count} archivos seleccionados",
    "uploadFile": "Subir archivo",
    "quantityUsed": "Cantidad Utilizada",
    "numberOfAnimals": "Número de animales",
    "temperature": "Temperatura promedio (°C)",
    "wetness": "Manejo de estiércol",
    "eggs": "Kilos de huevos producidos",
    "area": "Área (Hectáreas)",
    "areaPlaceHolder": "Área (Hectáreas)",
    "nofPassenger": "Nof Pasajeros",
    "distance": "Distancia",
    "card": {
      "emissionSourceManage": "Administra la fuentes de emisión",
      "completeCalculation": "Marca como terminado",
      "markExplanation": "Si terminaste el cálculo de esta categoría, puedes completarla aquí. Puedes deshacerlo en cualquier momento."
    },
    "carbonFootprintPeriod": {
      "ANNUAL": "Anual",
      "MONTHLY": "Mensual",
      "CUSTOM": "Personalizado"
    },
    "oneWay": "Solo ida",
    "return": "Ida y vuelta",
    "addEmission": {
      "title": "Agregar emisión",
      "subTitle": "Selecciona una o más"
    },
    "modal": {
      "title": "Datos de consumo",
      "subTitle": "Agrega tus consumos por periodo",
      "unitErrorDesc": "Ups, algo salió mal. No te preocupes, hemos sido notificados y estamos trabajando para arreglarlo lo antes posible, gracias.",
      "unitError": "Casi Listo"
    },
    "periodType": "Tipo de periodo",
    "consumption": "Consumo",
    "shortDescription": "Descripción corta",
    "uploadEvidence": "Subir evidencia",
    "month": "Mes",
    "customDate": "Selecciona inicio y cierre",
    "typeOfPeriod": "Tipo de periodo",
    "periodDate": "Fecha de periodo",
    "delete": "Eliminar",
    "actions": "Comportamiento",
    "edit": "Editar",
    "year": "Año",
    "Emission": "Emisión",
    "viewFile": "Ver Archivo",
    "deleteFile": "Borrar Archivo",
    "noData": "No hay datos disponibles",
    "departure": "Salida",
    "arrival": "Llegada",
    "distanceQuestion": "¿Conoces la distancia recorrida?",
    "from": "Punto de partida",
    "to": "Destino",
    "manureManagementTitle": "Manure Management Explanation",
    "manureManagement": "Manure Management",
    "selectManureManagement": "Select",
    "manureManagementTooltip": "Resumen del Manejo del Estiércol",
    "tooltip": {
      "title": "Detalle",
      "departure": "Selecciona o ingresa la ubicación de inicio de tu viaje o actividad.",
      "arrival": "Especifica el destino o punto final de tu viaje o actividad.",
      "shortDescription": "Proporciona un breve resumen del viaje o actividad como referencia.",
      "uploadEvidence": "Adjunta documentos de respaldo, como recibos o boletos, para verificar los datos de tu huella de carbono.",
      "consumption": "Ingresa la cantidad de combustible, electricidad u otros recursos consumidos durante el viaje o actividad.",
      "carbonStory": "Consulta el análisis de la huella de carbono de tu empresa, incluyendo datos históricos de emisiones e información sobre sostenibilidad.",
      "from": "Selecciona o ingresa la ubicación de inicio de tu viaje o actividad.",
      "to": "Especifica el destino o punto final de tu viaje o actividad.",
      "distanceQuestionToolTip": "Si está disponible, ingresa manualmente la distancia del viaje o confirma si deseas que se calcule automáticamente."
    },
    "yearLockedTitle": "Entrada de Datos Bloqueada",
    "yearLockedMessage": "La entrada de datos está bloqueada para este año y ya no se puede editar. Por favor contacta a tu administrador si necesitas realizar cambios."
  },
  "collaborator": {
    "form": {
      "title": "Agregar usuario",
      "firstName": "Nombre(s)",
      "lastName": "Apellido(s)",
      "email": "Correo electrónico",
      "position": "Rol en la empresa",
      "role": "Rol del usuario",
      "assigningFacility": "Asignar a instalación",
      "selectFacilities": "Selecciona una o más instalaciones",
      "button": "Send information"
    },
    "table": {
      "name": "Nombre",
      "email": "Correo electrónico",
      "position": "Posición dentro de la compañía",
      "facility": "Instalación",
      "actions": "Acciones"
    }
  },
  "analysis": {
    "emissions": "Emisiones",
    "allFacility": "Todas las instalaciones",
    "searchFacilityOrTags": "Busca por tag",
    "analysis": "Análisis",
    "searchForTag": "Busca for tag",
    "searchForFacility": "Busca por instalaciones",
    "scope": {
      "1": "Alcance 1",
      "2": "Alcance 2",
      "3": "Alcance 3",
      "BIOGENIC": "Biogénico",
      "Biogenic Emissions": "Emisiones Biogénicas"
    },
    "EMISSION_FACTOR_TYPES": {
      "STANDARD": "Emisiones Directas",
      "BIOGENIC": "Biogénico",
      "FLAG": "FLAG"
    },
    "FACILITY": "Instalaciones",
    "GHG": "categoría de protocolo GHG",
    "SCOPE": "Alcance",
    "EMISSION_GROUP": "Emisiones",
    "EMISSION_SOURCE": "Fuente de emisión",
    "EMISSION_TYPE": "Tipo de emisión",
    "all": "Todo",
    "total": "Total",
    "custom": "Personalizado",
    "Intensity": "Intensidad",
    "customDatePlaceholder": "Seleccione iniciar y cerrar",
    "EMPLOYEE": "Empleados",
    "INCOME": "Ingreso",
    "PRODUCTION": "Producción",
    "exportAnalysis": "Exportar análisis",
    "company": "Empresa",
    "COUNTRY": "País",
    "ALL_DATA_MSG": "Está viendo los 20 registros principales con los valores más altos en el gráfico. Haga clic en el botón de abajo para ver todos los datos."
  },
  "dashboard": {
    "carbonFootprint": "Emisiones",
    "carbonFootprintToolTip": "In this area you can see a quick emission summary of your company",
    "carbonStory": "Descarbonización",
    "goIntoDetail": "Ver detalle",
    "Notifications": "Notificaciones",
    "seeAll": "Ver todo",
    "Activity": "Actividad"
  },
  "reports": {
    "reports": "Reportes",
    "reportNumber": "Reporte {number}",
    "create": "Crear reporte",
    "type":"Tipo",
    "name":"Nombre",
    "creator":"Creador",
    "period":"Periodo",
    "actions":"Acciones",
    "createdAt":"Fecha de creación",
    "tooltips": {
      "download": "Descargar",
      "edit": "Editar",
      "viewGraphs": "Ver Gráficos",
      "hideGraphs": "Ocultar Gráficos",
      "delete": "Eliminar"
    },
    "badges": {
      "draft": "Borrador"
    },
    "loading": {
      "reportData": "Cargando datos del reporte...",
      "downloadingReport": "Descargando reporte..."
    },
    "errors": {
      "failedToLoadReportData": "Error al cargar datos del reporte",
      "failedToDownloadReport": "Error al descargar el reporte",
      "reportNotFound": "Reporte no encontrado"
    },
    "messages": {
      "noDataAvailable": "No hay datos disponibles para este reporte"
    },
    "reportType": {
      "title": "Tipo de reporte",
      "subtitle": "Selecciona el tipo de reporte que quieres crear",
      "internalReport": "Reporte interno",
      "ghgReport": "GHG",
      "selectPeriod": "Selecciona tipo de periodo"
    },
    "configInternalReport" : {
      "title": "Reporte interno",
      "subtitle": "Añade una sección a tu reporte",
      "chartTypePie": "Pay",
      "chartTypeBar": "Tiempo",
      "addToReport": "Añadir a reporte",
      "annual": "Anual",
      "name": "Nombre del gráfico",
      "description": "Descripción"
    },
    "internalReportReview": {
      "title": "Revisa tu reporte",
      "subtitle": "Antes de guardar, revisa una última vez tu reporte",
      "companyInformation": "Company's information",
      "companyName": "Company name",
      "sector": "Sector",
      "askReportName": "Ingrese nombre del reporte",
      "setReportName": "Nombre del reporte",
      "subSector": "Subsector",
      "saveReport": "Guardar reporte",
      "creatingReport":"Generando Reporte"
    },
    "entityName": "Reporte GEI",
    "entityFields": {
      "improvements": "Mejoras de Aseguramiento de Calidad e Inventario",
      "contractual-provisions": "Disposiciones Contractuales",
      "management-programs": "Programas de Gestión",
      "generated-energy": "Energía Generada",
      "resold-energy": "Energía Revendida",
      "base-year-recalc-policy": "Política de Recálculo del Año Base",
      "emission-change-context": "Contexto de Cambio de Emisiones",
      "calc-methods-tools": "Métodos y Herramientas de Cálculo",
      "sequestration": "Secuestro"
    },
    "ghg": {
      "steps": {
        "COMPANY_VERIFICATION_INFO": "Información de Empresa y Verificación",
        "REPORTING_SCOPE_BOUNDARIES": "Alcance de Reporte y Límites",
        "EMISSIONS_OVERVIEW": "Resumen de Emisiones",
        "EMISSION_SOURCES_BREAKDOWN": "Fuentes de Emisión y Desglose",
        "BASE_YEAR_TRENDS": "Año Base y Tendencias Históricas",
        "METHODOLOGIES_ORGANIZATION": "Metodologías y Estructura Organizacional",
        "GHG_MANAGEMENT_REDUCTION": "Gestión y Reducción de GEI",
        "OFFSETS_ADDITIONAL_DISCLOSURES": "Compensaciones y Divulgaciones Adicionales"
      },
      "actions": {
        "saveAndDownload": "Guardar y Descargar",
        "previewReport": "Vista Previa del Reporte",
        "saveDraft": "Guardar Borrador"
      },
      "draftSavedMessage":"Su borrador del informe GEI se ha guardado exitosamente.",
      "draftSavedHeader":"Borrador Guardado",
      "reportCompletionStatus": "Estado de Finalización del Reporte",
      "baseYearTrends": {
        "title": "Año Base y Tendencias Históricas",
        "sectionCompletion": "Finalización de sección",
        "baseYearInfo": "Información del Año Base",
        "baseYearSelection": "Selección del Año Base",
        "baseYearPlaceholder": "AAAA",
        "baseYearHelper": "Seleccione el año que servirá como línea base para la comparación",
        "recalculationPolicy": {
          "title": "Política de Recálculo de Emisiones del Año Base",
          "description": "Define cuándo y cómo se recalcularán las emisiones del año base",
          "placeholder": "Describa su política para recalcular las emisiones del año base (ej: umbrales para recálculo, cambios estructurales, actualizaciones de metodología)...",
          "aiAssist": "Asistencia IA",
          "skipSection": "Omitir esta sección",
          "sectionSkipped": "Esta sección ha sido omitida"
        },
        "emissionsChanges": {
          "title": "Contexto de Cambios en Emisiones",
          "description": "Explique cambios significativos en emisiones comparado con años anteriores",
          "placeholder": "Proporcione contexto para cualquier cambio significativo en emisiones (ej: expansión del negocio, cambios operacionales, mejora en calidad de datos)...",
          "aiAssist": "Asistencia IA",
          "skipSection": "Omitir esta sección",
          "sectionSkipped": "Esta sección ha sido omitida"
        },
        "baseYearEmissions": {
          "title": "Datos de Emisiones del Año Base",
          "infoText": "Ingrese los datos de emisiones para su año base seleccionado. Esto servirá como línea base para comparaciones futuras.",
          "headers": {
            "baseYear": "Año Base",
            "total": "Total (tCO2e)",
            "co2": "CO2 (tCO2e)",
            "ch4": "CH4 (tCO2e)",
            "n2o": "N2O (tCO2e)",
            "hfcs": "HFCs (tCO2e)",
            "pfcs": "PFCs (tCO2e)",
            "sf6": "SF6 (tCO2e)"
          }
        },
        "historicalData": {
          "title": "Datos Históricos de Emisiones GEI",
          "noData": "No hay datos históricos de emisiones disponibles",
          "noDataHelper": "Los datos históricos se completarán desde sus reportes anteriores",
          "headers": {
            "year": "Año"
          }
        },
        "intensityMetrics": {
          "title": "Métricas de Intensidad",
          "aiAssist": "Asistencia IA",
          "noteTitle": "Nota:",
          "noteText": "Las métricas de intensidad ayudan a normalizar los datos de emisiones y pueden incluir métricas como emisiones por ingresos, por empleado, por unidad de producción, etc.",
          "noData": "No hay métricas de intensidad disponibles",
          "noDataHelper": "Las métricas de intensidad se calcularán basándose en sus datos operacionales",
          "headers": {
            "intensityType": "Tipo de Intensidad",
            "value": "Valor"
          }
        }
      },
      "companyVerificationInfo": {
        "title": "Información de Empresa y Verificación",
        "sectionCompletion": "Finalización de sección",
        "companyInfo": {
          "title": "Información de la Empresa",
          "reportName": "Nombre del Reporte",
          "reportNamePlaceholder": "Ingrese el nombre del reporte",
          "inventoryYear": "Año del Inventario",
          "inventoryYearPlaceholder": "AAAA"
        },
        "verificationInfo": {
          "title": "Información de Verificación",
          "isVerifiedQuestion": "¿Este reporte está verificado por un tercero?",
          "verificationOptions": {
            "notVerified": "No Verificado",
            "verified": "Verificado"
          },
          "verifierName": "Nombre del Verificador",
          "verifierNamePlaceholder": "Ingrese el nombre del verificador",
          "verificationDate": "Fecha de Verificación",
          "verifierEmail": "Email del Verificador",
          "verifierEmailPlaceholder": "email{'@'}ejemplo.com",
          "verifierPhone": "Teléfono del Verificador",
          "verifierPhonePlaceholder": "+1 (555) 123-4567",
          "verifierAddress": "Dirección del Verificador",
          "verifierAddressPlaceholder": "Ingrese la dirección del verificador"
        }
      },
      "emissionSourcesBreakdown": {
        "title": "Fuentes de Emisión y Desglose",
        "sectionCompletion": "Finalización de sección",
        "calculatedFromEmissionData": "Calculado desde datos de emisión",
        "calculatedFromFacilityData": "Calculado desde datos de instalaciones",
        "calculatedFromLocationData": "Calculado desde datos de ubicación",
        "scopes": {
          "scope1": "Alcance 1",
          "scope2": "Alcance 2",
          "scope3": "Alcance 3",
          "scope1Title": "Alcance 1: Emisiones Directas",
          "scope2Title": "Alcance 2: Emisiones Indirectas",
          "scope3Title": "Alcance 3: Otras Emisiones Indirectas"
        },
        "emissionSources": {
          "co2Emissions": "Emisiones CO2",
          "ch4Emissions": "Emisiones CH4",
          "n2oEmissions": "Emisiones N2O",
          "hfcsEmissions": "Emisiones HFCs",
          "pfcsEmissions": "Emisiones PFCs",
          "sf6Emissions": "Emisiones SF6",
          "totalScope1": "Total Alcance 1",
          "totalScope2": "Total Alcance 2",
          "totalScope3": "Total Alcance 3"
        },
        "tableHeaders": {
          "emissionSource": "Fuente de Emisión",
          "value": "Valor (tCO2e)",
          "facilityName": "Nombre de Instalación",
          "country": "País",
          "scope1": "Alcance 1 (tCO2e)",
          "scope2": "Alcance 2 (tCO2e)",
          "scope3": "Alcance 3 (tCO2e)",
          "total": "Total (tCO2e)"
        },
        "tabs": {
          "emissionsByFacility": "Emisiones por Instalación",
          "emissionsByCountry": "Emisiones por País"
        },
        "noDataMessages": {
          "noScope1Data": "No hay datos de emisiones de Alcance 1 disponibles",
          "noScope2Data": "No hay datos de emisiones de Alcance 2 disponibles",
          "noScope3Data": "No hay datos de emisiones de Alcance 3 disponibles",
          "noFacilityData": "No hay datos de emisiones de instalaciones disponibles",
          "noCountryData": "No hay datos de emisiones por país disponibles"
        },
        "facilityNote": "Requerido para instalaciones con emisiones >10,000 tCO2e según las directrices del Protocolo GEI.",
        "additionalDisclosures": {
          "title": "Divulgaciones Adicionales",
          "actionRequired": "Acción Requerida",
          "generatedEnergy": {
            "title": "Energía Generada",
            "description": "Actividades de generación de energía y emisiones asociadas",
            "label": "Detalles de Energía Generada",
            "placeholder": "Describa sus actividades de generación de energía, cantidades (MWh), y emisiones asociadas (tCO2e)",
            "aiAssist": "Asistencia IA",
            "skipSection": "Omitir esta sección",
            "sectionSkipped": "Esta sección ha sido omitida"
          },
          "resoldEnergy": {
            "title": "Energía Revendida",
            "description": "Actividades de reventa de energía y emisiones asociadas",
            "label": "Detalles de Energía Revendida",
            "placeholder": "Describa sus actividades de reventa de energía, cantidades (MWh), y emisiones asociadas (tCO2e)",
            "aiAssist": "Asistencia IA",
            "skipSection": "Omitir esta sección",
            "sectionSkipped": "Esta sección ha sido omitida"
          },
          "noteTitle": "Nota:",
          "noteText": "Estas secciones son opcionales. Puede omitirlas si su organización no genera o revende energía, o proporcionar detalles si corresponde."
        }
      },
      "emissionsOverview": {
        "title": "Resumen de Emisiones",
        "sectionCompletion": "Finalización de sección",
        "scopeEmissionData": {
          "title": "Datos de Emisión por Alcance",
          "description": "Emisiones totales por alcance y gases de efecto invernadero individuales",
          "calculatedNote": "(Calculado desde datos de emisión)",
          "noDataMessage": "No hay datos de emisión disponibles aún. Complete los pasos de cálculo de emisiones para ver los datos aquí."
        },
        "totalEmissionsSummary": {
          "title": "Resumen de Emisiones Totales",
          "scope1": "Alcance 1",
          "scope2": "Alcance 2",
          "scope3": "Alcance 3",
          "totalEmissions": "Emisiones Totales:",
          "unit": "tCO2e"
        },
        "biogenicEmissions": {
          "title": "Emisiones de CO2 Biogénico",
          "description": "Emisiones de CO2 de la combustión de biomasa/biocombustibles",
          "reportedSeparately": "(Reportadas por separado de los alcances)",
          "subtitle": "Emisiones de CO2 Biogénico",
          "directEmissions": "Emisiones directas de CO2 de fuentes biogénicas",
          "unit": "tCO2",
          "protocolNote": "Las emisiones biogénicas se reportan por separado y no se incluyen en los totales por alcance según los estándares del Protocolo GEI."
        },
        "tableHeaders": {
          "scope": "Alcance",
          "totalCO2e": "Total CO2e (tCO2e)",
          "co2": "CO2 (tCO2e)",
          "ch4": "CH4 (tCO2e)",
          "n2o": "N2O (tCO2e)",
          "hfcs": "HFCs (tCO2e)",
          "pfcs": "PFCs (tCO2e)",
          "sf6": "SF6 (tCO2e)"
        }
      },
      "ghgManagementReduction": {
        "title": "Gestión y Reducción de GEI",
        "sectionCompletion": "Finalización de sección",
        "managementPrograms": {
          "title": "Programas de Gestión de GEI",
          "actionRequired": "Acción Requerida",
          "programsTitle": "Programas y Procedimientos de Gestión",
          "description": "Describa los procedimientos operacionales, sistemas de monitoreo, marcos de gobernanza y programas de cumplimiento",
          "placeholder": "Describa sus programas y procedimientos de gestión de GEI...",
          "aiAssist": "Asistencia IA",
          "skipSection": "Omitir esta sección",
          "sectionSkipped": "Esta sección ha sido omitida",
          "examplesTitle": "Ejemplos a incluir:",
          "examples": {
            "monitoring": "Monitoreo continuo de emisiones, procedimientos de recolección de datos",
            "governance": "Estructura del comité climático, protocolos de reporte, procesos de toma de decisiones",
            "compliance": "Programas de cumplimiento regulatorio, procedimientos de auditoría interna",
            "training": "Programas de concientización para empleados, iniciativas de desarrollo de capacidades",
            "technology": "Tecnologías de reducción de emisiones, mejoras de eficiencia",
            "targets": "Objetivos basados en ciencia, metas de reducción, compromisos de cronograma"
          },
          "exampleLabels": {
            "monitoring": "Sistemas de Monitoreo:",
            "governance": "Gobernanza:",
            "compliance": "Cumplimiento:",
            "training": "Capacitación:",
            "technology": "Tecnología:",
            "targets": "Objetivos:"
          }
        },
        "managementFramework": {
          "title": "Marco de Gestión de GEI",
          "monitoring": {
            "title": "Monitoreo",
            "description": "Recolección y seguimiento de datos"
          },
          "governance": {
            "title": "Gobernanza",
            "description": "Supervisión y responsabilidad"
          },
          "compliance": {
            "title": "Cumplimiento",
            "description": "Adherencia regulatoria"
          },
          "reduction": {
            "title": "Reducción",
            "description": "Logro de objetivos"
          }
        },
        "bestPractices": {
          "title": "Mejores Prácticas de Gestión de GEI",
          "keyElements": {
            "title": "Elementos Clave de Gestión",
            "establishRoles": "Establecer roles y responsabilidades claros",
            "implementMonitoring": "Implementar monitoreo y reporte regular",
            "setScienceTargets": "Establecer objetivos de reducción basados en ciencia",
            "engageSuppliers": "Involucrar proveedores y socios de la cadena de valor"
          },
          "reductionStrategies": {
            "title": "Estrategias de Reducción",
            "energyEfficiency": "Mejoras de eficiencia energética",
            "renewableEnergy": "Adopción de energía renovable",
            "processOptimization": "Optimización de procesos e innovación",
            "supplyChainEngagement": "Participación de la cadena de suministro"
          }
        }
      },
      "methodologiesOrganization": {
        "title": "Metodologías y Estructura Organizacional",
        "sectionCompletion": "Finalización de sección",
        "calculationMethods": {
          "title": "Métodos y Herramientas de Cálculo",
          "actionRequired": "Acción Requerida",
          "methodsTitle": "Métodos y Herramientas de Cálculo",
          "description": "Describa las metodologías, factores de emisión y herramientas de cálculo utilizadas",
          "placeholder": "Describa las metodologías, factores de emisión y herramientas de cálculo utilizadas en la preparación de este inventario (ej: estándares del Protocolo GEI, bases de datos específicas como EPA eGRID, software de cálculo utilizado)...",
          "aiAssist": "Asistencia IA",
          "skipSection": "Omitir esta sección",
          "sectionSkipped": "Esta sección ha sido omitida",
          "examples": "Estándar Corporativo del Protocolo GEI, Factores de Emisión EPA, factores de conversión DEFRA, herramientas de cálculo propietarias, plataformas de software de terceros",
          "examplesLabel": "Ejemplos:"
        },
        "organizationalStructure": {
          "title": "Estructura Organizacional",
          "description": "Esta sección muestra las entidades/instalaciones incluidas en su límite organizacional basado en su enfoque de consolidación.",
          "noEntitiesMessage": "No hay entidades/instalaciones disponibles",
          "noEntitiesHelper": "Los datos de entidades se completarán desde su configuración organizacional",
          "tableHeaders": {
            "entityFacilityName": "Nombre de Entidad/Instalación",
            "location": "Ubicación",
            "type": "Tipo",
            "scopesIncluded": "Alcances Incluidos",
            "notSpecified": "No especificado"
          }
        },
        "consolidationSummary": {
          "title": "Resumen de Consolidación",
          "totalEntities": "Total de Entidades",
          "entitiesUnit": "Instalaciones/Entidades",
          "consolidationApproach": "Enfoque de Consolidación",
          "selectedMethod": "Método Seleccionado",
          "coverage": "Cobertura",
          "includeScope3": "Incluye Alcance 3",
          "approaches": {
            "equityShare": "Participación Accionaria",
            "financialControl": "Control Financiero",
            "operationalControl": "Control Operacional",
            "notSpecified": "No especificado"
          }
        }
      },
      "offsetsAdditionalDisclosures": {
        "title": "Compensaciones y Divulgaciones Adicionales",
        "sectionCompletion": "Finalización de sección",
        "additionalDisclosures": {
          "title": "Divulgaciones Adicionales",
          "actionRequired": "Acción Requerida"
        },
        "contractualProvisions": {
          "title": "Disposiciones Contractuales de GEI",
          "description": "Acuerdos contractuales relacionados con emisiones de GEI y disposiciones de distribución de riesgos",
          "placeholder": "Describa cualquier acuerdo contractual relacionado con emisiones de GEI, como disposiciones de distribución de riesgos, límites de emisión, o asignación contractual de responsabilidades de emisiones...",
          "aiAssist": "Asistencia IA",
          "skipSection": "Omitir esta sección",
          "sectionSkipped": "Esta sección ha sido omitida",
          "examplesLabel": "Ejemplos:",
          "examples": "Acuerdos de asignación de emisiones en joint ventures, requisitos de emisión para proveedores, límites de emisión para clientes, cláusulas de responsabilidad compartida"
        },
        "qualityAssurance": {
          "title": "Aseguramiento de Calidad y Mejoras del Inventario",
          "description": "Procedimientos de aseguramiento de calidad y planes para futuras mejoras del inventario",
          "placeholder": "Describa los procedimientos de aseguramiento de calidad implementados para garantizar la precisión del inventario de GEI y planes para futuras mejoras...",
          "aiAssist": "Asistencia IA",
          "skipSection": "Omitir esta sección",
          "sectionSkipped": "Esta sección ha sido omitida",
          "examplesLabel": "Ejemplos:",
          "examples": "Procedimientos de verificación de datos, auditorías de terceros, mejoras metodológicas, sistemas de monitoreo mejorados, programas de capacitación del personal"
        },
        "sequestration": {
          "title": "Actividades de Secuestro de GEI",
          "description": "Actividades de secuestro y remoción de carbono que posee o controla su organización",
          "placeholder": "Describa las actividades de secuestro de GEI, incluyendo reforestación, proyectos de carbono del suelo, captura directa de aire, u otras iniciativas de remoción de carbono...",
          "aiAssist": "Asistencia IA",
          "skipSection": "Omitir esta sección",
          "sectionSkipped": "Esta sección ha sido omitida",
          "examplesLabel": "Ejemplos:",
          "examples": "Proyectos de restauración forestal, agricultura regenerativa, aplicaciones de biocarbón, tecnologías de captura directa de aire, meteorización mejorada, captura y almacenamiento de carbono"
        }
      },
      "reportingScopeBoundaries": {
        "title": "Alcance de Reporte y Límites",
        "sectionCompletion": "Finalización de sección",
        "reportingPeriod": {
          "title": "Período de Reporte",
          "startDate": "Fecha de Inicio",
          "endDate": "Fecha de Fin",
          "prefilled": "(Prellenado)",
          "infoNote": "El período de reporte es típicamente un año calendario (1 de enero - 31 de diciembre)."
        },
        "organizationalBoundaries": {
          "title": "Límites Organizacionales",
          "consolidationApproach": "Enfoque de Consolidación",
          "equityShare": {
            "title": "Participación Accionaria",
            "description": "Reportar una porción de emisiones correspondiente a la participación accionaria de la empresa en la operación."
          },
          "financialControl": {
            "title": "Control Financiero",
            "description": "Reportar 100% de las emisiones de operaciones sobre las cuales la empresa tiene control financiero."
          },
          "operationalControl": {
            "title": "Control Operacional",
            "description": "Reportar 100% de las emisiones de operaciones sobre las cuales la empresa tiene control operacional."
          },
          "consistencyNote": "El enfoque de consolidación debe ser consistente con su enfoque de reporte financiero y aplicado consistentemente a través de todos los períodos de reporte."
        }
      },
      "preview": {
        "title": "Vista Previa del Reporte GEI",
        "notAvailable": "N/D",
        "reportHeader": {
          "title": "Informe de Emisiones de Gases de Efecto Invernadero",
          "reportingYear": "Año de Reporte",
          "reportLanguage": "Idioma del Reporte",
          "reportingPeriod": "Período de Reporte"
        },
        "verification": {
          "status": "Estado de Verificación"
        },
        "emissions": {
          "totalByScope": "Emisiones Totales por Alcance",
          "detailedByGasType": "Emisiones Detalladas por Tipo de Gas"
        },
        "units": {
          "tco2e": "tCO2e",
          "tco2": "tCO2"
        },
        "biogenic": {
          "note": "Nota: Las emisiones biogénicas se reportan por separado y no se incluyen en los totales por alcance según los estándares del Protocolo GEI."
        },
        "baseYear": {
          "year": "Año Base"
        },
        "footer": {
          "generatedOn": "Este reporte fue generado el"
        }
      }
    }
  },
  "target": {
    "title": "Objetivos"
  },
  "transportation": {
    "hgvType": "Tipo de HGV",
    "vanType": "Tipo de Furgoneta",
    "ladenPercentage": "Porcentaje de Carga",
    "Unknown": "Desconocido",
    "Rigid (>3.5 - 7.5 tonnes)": "Rígido (>3.5 - 7.5 toneladas)",
    "Rigid (>7.5 tonnes-17 tonnes)": "Rígido (>7.5 - 17 toneladas)",
    "Rigid (>17 tonnes)": "Rígido (>17 toneladas)",
    "All rigids": "Todos los rígidos",
    "Articulated (>3.5 - 33t)": "Articulado (>3.5 - 33 toneladas)",
    "Articulated (>33t)": "Articulado (>33 toneladas)",
    "All artics": "Todos los articulados",
    "All HGVs": "Todos los HGVs",
    "Class I (up to 1.305 tonnes)": "Clase I (hasta 1.305 toneladas)",
    "Class II (1.305 to 1.74 tonnes)": "Clase II (1.305 a 1.74 toneladas)",
    "Class III (1.74 to 3.5 tonnes)": "Clase III (1.74 a 3.5 toneladas)"
  },
  "survey": {
    "autoFilledTooltip": "Este campo será completado automáticamente por el sistema. No es necesario que ingreses información.",
    "q1": "¿Calculan la huella de carbono en tu compañía?",
    "q2": "¿Calculan alcance 1 - emisiones directas?",
    "q3": "¿Calculan alcance 2- Emisiones indirectas energéticas?",
    "q4": "¿Han mapeado su alcance 3 - emisiones indirectas?",
    "q5": "¿Miden su alcance 3?",
    "q6": "¿Verifican su emisiones de alcance 1 y 2 con un tercero?",
    "q7": "¿Verifican sus emisiones de alcance 3 con un tercer?",
    "q8": "¿Tienen una meta de energía renovable?",
    "q9": "¿Son parte de alguna iniciativa como RE100?",
    "q10": "¿Qué % de la energía que compran es renovable?",
    "q11": "¿Están avanzando con energía térmica (calor) renovable?",
    "q12": "¿Qué porcentage de la energía térmica (calor) que usan es renovable?",
    "q13": "¿Reportan y publican los alcances 1 y 2 anualmente y sus avances?",
    "q14": "¿Reportan al CDP?",
    "q15": "¿Hoy en día están involucrando a sus proveedores para que reporten en CDP?",
    "q16": " ¿Reportan y publican el alcance 3 anualmente y sus avances?",
    "q17": "¿Cuál fue su calificación del CDP el año pasado?",
    "q18": "¿Tienen actualmente algún objetivo asociado al clima?",
    "q19": "¿Su objetivo está alineado o aprobado por la iniciativa Science-Based Target?",
    "q20": "Si no tiene un objetivo, ¿tiene planes para establecer un objetivo en el próximo año?",
    "q21": "¿Informan públicamente sobre el progreso hacia su objetivo?",
    "q22": "¿Han mapeado sus planes año a año ​​para alcanzar su meta?",
    "q23": "¿Han identificado riesgos y oportunidades relacionados con el clima?",
    "q24": "¿Están siguiendo algún marco como TCFD?",
    "q25": "¿El clima está integrado en la estrategia de su negocio?",
    "q26": "Han establecido un objetivo Net Zero (Cero neto)?",
    "q27": "Si es así, ¿cuál es el año objetivo?",
    "q28": "Si no es así, ¿planean definir este objetivo en los próximos 2 años?",
    "q29": "¿Han desarrollado un camino claro de descarbonización hacia el cero neto?",
    "categories": {
      "CARBON_ACCOUNTING": "Carbon Accounting",
      "RENEWABLES": "Renewables",
      "REPORTING": "Reporting",
      "TARGET_SETTING": "Target Setting",
      "CLIMATE_STRATEGY": "Climate Strategy",
      "NET_ZERO_READINESS": "Net Zero Readiness"
    },
    "yourAnswer": "Su respuesta",
    "comment": "Comentarios (opcional)",
    "errorMsg": "Los campos marcados con * son obligatorios.",
    "thankYou": "Hemos recibido tus respuestas, gracias por dar el primer paso hacia la descarbonización"
  },
  "companyInformation": {
    "companyInfo": "Información de la empresa"
  },
  "decarbonization": {
    "addToRoadMap": "Add to Roadmap",
    "selectFacility": "¡Por favor primero selecciona una instalación!",
    "allCompany": "Toda la compañía",
    "addMyOwnSolution": "Agregar mi propia solución",
    "totalFootprint": "Emisiones totales en la línea base",
    "Average": "$ Costo por tco2",
    "roadMapCost": "Costo del Roadmap",
    "projectCost": "Costo del proyecto",
    "totalNeeded": "Capital requerido",
    "totalCo2Reduced": "Emisiones reducidas",
    "learnMoreInOutBlog": "Aprende más en nuestro Blog",
    "marketPlaceRedirectButton": "Solicita cotizaciones a los mejores proveedores de tu zona",
    "selectedEmissionGroup": "Grupo de emisión seleccionado",
    "components": {
      "solutions": "Soluciones",
      "road-map": "Roadmap",
      "goals": "Objetivos"
    },
    "form": {
      "projectName": "Nombre del proyecto",
      "spanMonth": "Duración del proyecto en meses",
      "cost": "Costo",
      "emissionReductionPercentage": "Porcentaje de reducción de emisiones",
      "emissionGroup": "Selecciona un grupo de emisión",
      "emissionSourceList": "Fuente de emisión"
    },
    "infoMsg": {
      "title": "Lo sentimos.",
      "description": "Todavía no hay ninguna solución activa en el grupo de emisiones seleccionado. Puede añadir su propia solución o seleccionar otro grupo de emisiones."
    },
    "costEstimationMessage":"Este es un costo estimado, podría cambiar al ser cotizado"
  },
  "goal": {
    "form": {
      "title": "Agregar objetivo",
      "saveTarget": "Guardar objetivo",
      "targetName": "Nombre del objetivo",
      "targetType": "Tipo de objetivo",
      "targetScopes": "Alcance del objetivo",
      "emissionGroup": "Grupo de emisión",
      "baseYear": "Año base",
      "targetYear": "Año objetivo",
      "SCIENCE_BASED": "Basado en ciencia ",
      "INITIATIVES": "Iniciativas",
      "CUSTOM": "Personalizado",
      "successMsg": "¡Objetivo agregado! Objetivo creado con éxito",
      "reductionPercentage": "Reducción",
      "validation": {
        "targetName": "El nombre del objetivo es requerido",
        "baseYear": "El año base es requerido",
        "targetYear": "El año objetivo es requerido",
        "reductionPercentage": "El porcentaje de reducción es requerido",
        "emissionGroup": "Debes seleccionar al menos un alcance",
        "targetScopes": "You must select at least one target scope"
      }
    },
    "title": "Objetivos",
    "newTarget": "Nuevo objetivo",
    "deleteAlert": "El registro será eliminado, ¿Deseas continuar?",
    "legends": {
      "baseline": "Línea base",
      "baselineDescription": "",
      "businessAsUsual": "Business as usual",
      "businessAsUsualDescription": "Si continuas haciendo lo que estás haciendo",
      "targetsWithInitiatives": "Objetivos con las iniciativas",
      "targetsWithInitiativesDescription": "A donde puedes llegar al atacar esos procesos",
      "sbtiTargets": "Objetivos SBTi",
      "sbtiTargetsDescription": "En donde espera estar la compañía",
      "historicEmissions": "Historial de emisiones",
      "historicEmissionsDescription": "Primer cálculo de huella de carbono",
      "selectedTargets": "Objetivos seleccionados",
      "targetSelected": "Objetivo seleccionado"
    },
    "table": {
      "targetName": "Nombre del objetivo",
      "scope": "Alcance del objetivo",
      "emissions": "Emisiones",
      "targetYear": "Año objetivo",
      "reduction": "Reducción"
    },
    "emissionTable": {
      "emissionGroup": "Grupo de emisión"
    }
  },
  "terms": {
    "title": "Términos y Condiciones",
    "explanation": "Debes aceptar ambas opciones para continuar.",
    "errorMsg": "Por favor acepta ambas opciones para continuar"
  },
  "messages": {
    "addedEmission": "Emisión añadida con éxito",
    "addedEmissionError": "Error al añadir emisión",
    "noDateError": "Por favor selecciona una fecha"
  },
  "farmAnimals": {
    "wet": "Húmedo",
    "dry": "Seco",
    "aeration": "Areación",
    "solidStorage": "Almacenamiento Sólido",
    "solidStorageDesc": "El almacenamiento de estiércol, típicamente durante un período de varios meses, en montones o pilas no confinadas. El estiércol puede apilarse debido a la presencia de una cantidad suficiente de material de cama o la pérdida de humedad por evaporación.",
    "dryLot": "Lote Seco",
    "dryLotDesc": "Un área de confinamiento abierta pavimentada o no pavimentada sin una cobertura vegetal significativa, donde el estiércol acumulado puede ser retirado periódicamente. Los lotes secos se encuentran más comúnmente en climas secos, pero también se usan en climas húmedos.",
    "liquidSlurry": "Líquido / Lodo",
    "liquidSlurryDesc": "El estiércol se almacena tal como se excreta o con una mínima adición de agua para facilitar su manejo y se almacena en tanques o estanques de tierra.",
    "uncoveredAnaerobicLagoon": "Laguna Anaeróbica Descubierta",
    "uncoveredAnaerobicLagoonDesc": "Las lagunas anaeróbicas están diseñadas y operadas para combinar la estabilización de desechos y el almacenamiento. El sobrenadante de la laguna generalmente se utiliza para retirar el estiércol de las instalaciones de confinamiento asociadas a la laguna. Las lagunas anaeróbicas están diseñadas con diferentes longitudes de almacenamiento (hasta un año o más), dependiendo de la región climática, la tasa de carga de sólidos volátiles y otros factores operativos. El agua de la laguna puede ser reciclada como agua de lavado o utilizada para regar y fertilizar los campos.",
    "pitStorageBelowConfinements": "Almacenamiento en fosa bajo confinamiento animal",
    "pitStorageBelowConfinementsDesc": "Colección y almacenamiento de estiércol, usualmente con poca o ninguna adición de agua, típicamente debajo de un piso de listones en una instalación de confinamiento de animales cerrada.",
    "anaerobicDigester": "Digestor Anaeróbico",
    "anaerobicDigesterDesc": "Los digestores anaeróbicos están diseñados y operados para la estabilización de desechos mediante la reducción microbiana de compuestos orgánicos complejos a CH4 y CO2, que se capturan y se queman o se utilizan como combustible.",
    "compostingInVessel": "Compostaje en Recipiente Cerrado",
    "compostingInVesselDesc": "Compostaje, típicamente en un canal cerrado, con aireación forzada y mezcla continua.",
    "compostingStaticPile": "Compostaje en Pila Estática",
    "compostingStaticPileDesc": "Compostaje en pilas con aireación forzada pero sin mezcla.",
    "aerobicTreatmentNatural": "Tratamiento Aeróbico (Sistemas de Aireación Natural)",
    "aerobicTreatmentNaturalDesc": "La oxidación biológica del estiércol recogido como líquido con aireación forzada o natural. La aireación natural está limitada a sistemas de lagunas aeróbicas y facultativas, y a sistemas de humedales, y se debe principalmente a la fotosíntesis. Por lo tanto, estos sistemas típicamente se vuelven anóxicos durante los períodos sin luz solar.",
    "aerobicTreatmentForced": "Tratamiento Aeróbico (Sistemas de Aireación Forzada)",
    "aerobicTreatmentForcedDesc": "Tratamiento aeróbico usando sistemas de aireación forzada.",
    "poultryManure": "Estiércol de Aves de Corral",
    "poultryManureDesc": "Similar a los sistemas de cama profunda. Usualmente se utiliza para todos los rebaños de reproductores de aves y para la producción de pollos de carne (broilers) y otras aves."
  },
  "Collaborators": "Usuarios",
  "addCollaborators": "Agregar Usuarios",
  "userInfo": {
    "userInformation": "Información de Usuario",
    "name": "Nombre",
    "lastName": "Apellido",
    "password": "Contraseña",
    "passwordUpdate": "Cambiar contraseña/Actualizar",
    "position": "Posición en la compañía",
    "passwordUpdateModalTitle": "Actualizar Contraseña"
  },
  "facilityFilters": {
    "search": "Buscar instalaciones",
    "facilityName": "Nombre de la instalación",
    "facilityType": "Tipo de instalación",
    "tags": "Etiquetas",
    "countries": "Países",
    "calculationStatus": "Estado de cálculo",
    "showAll": "Mostrar todo",
    "completed": "Completado",
    "pending": "Pendiente",
    "apply": "Aplicar",
    "save": "Guardar",
    "clear": "Limpiar",
    "activeFilters": "Hay filtros activos",
    "NO_DATA": "No se ha encontrado ninguna instalación. Cambie los criterios de filtrado."
  },
  "ANALYSIS_FILTER_BAR_COMPONENT": {
    "BREAKDOWNS": "Breakdowns",
    "GROUPS": "Groups"
  },
  "MONTH_1": "Enero",
  "MONTH_2": "Febrero",
  "MONTH_3": "Marzo",
  "MONTH_4": "Abril",
  "MONTH_5": "Mayo",
  "MONTH_6": "Junio",
  "MONTH_7": "Julio",
  "MONTH_8": "Agosto",
  "MONTH_9": "Septiembre",
  "MONTH_10": "Octubre",
  "MONTH_11": "Noviembre",
  "MONTH_12": "Diciembre",
  "UNNAMED_FACILITY": "Instalación sin nombre",
  "DELETED_FACILITY_TO_BE_REMOVED": "Borre la instalación que desea eliminar.",
  "bulkUploads": {
    "status": {
      "UPLOADED": "Subido",
      "VALIDATING": "Validando",
      "VALIDATION_INPUT_REQUIRED": "Entrada de validación requerida",
      "VALIDATED": "Validado",
      "CORRECTING": "Corrigiendo",
      "PROCESSING": "Procesando",
      "PROCESSED": "Procesado",
      "PROCESSED_WITH_ERRORS": "Procesado con errores",
      "ERROR": "Error"
    },
    "lineStatus": {
      "VALID": "Válido",
      "NEEDS_CORRECTION": "Necesita corrección",
      "PROCESSED": "Procesado",
      "NOT_PROCESSED": "No procesado"
    }
  },
  "SUBMIT_SUCCESS_MESSAGE": "Formulario enviado con éxito",
  "CARBON_ACCOUNTING_USER": "Responsable de la instalación",
  "CARBON_ACCOUNTING_ADMIN": "Admin",
  "CARBON_ACCOUNTING_READ_ONLY": "Solo lectura",
  "EXTERNAL_IDP_USER_CREATE_WARNING_MSG_TITLE": "No puedes realizar esta acción aquí.",
  "EXTERNAL_IDP_USER_CREATE_WARNING_MSG_EXPLANATION": "Tu método de acceso (por ejemplo, cuenta de la empresa) está gestionado por un sistema de identidad externo.\nPara añadir un nuevo usuario, por favor contacta con el equipo de IT de tu empresa.",
  "dataReport": {
    "reportView": "Vista de Reporte",
    "table": "Tabla",
    "chart": "Gráfico",
    "insight": "Análisis",
    "selectChartType": "Seleccionar tipo de gráfico",
    "editQuery": "Editar Consulta",
    "updateReport": "Actualizar Reporte",
    "backToReport": "Volver al Reporte",
    "hideQueryBuilder": "Ocultar constructor de consultas",
    "reportSavedSuccessfully": "¡Reporte guardado exitosamente!",
    "failedToSaveReport": "Error al guardar el reporte",
    "failedToRunQuery": "Error al ejecutar la consulta"
  },
  "dataExplorer": {
    "title": "Explorador de Datos",
    "subtitle": "Construir y analizar consultas con interfaz visual de arrastrar y soltar",
    "saveQuery": "Guardar Consulta",
    "saveReport": "Guardar Reporte",
    "savedQueries": "Consultas Guardadas",
    "showQueryBuilder": "Mostrar Constructor de Consultas",
    "hideQueryBuilder": "Ocultar Constructor de Consultas",
    "getStarted": "Comenzar con la Exploración de Datos",
    "emptyStateDescription": "Selecciona una entidad del menú desplegable para comenzar a construir consultas, explorar datos y crear visualizaciones.",
    "chooseEntity": "Elige una entidad para comenzar",
    "showingResults": "Mostrando {count} resultados",
    "table": "Tabla",
    "chart": "Gráfico",
    "selectChartType": "Seleccionar tipo de gráfico",
    "noEntitySelected": "No se ha seleccionado ninguna entidad",
    "pleaseSelectEntity": "Por favor selecciona una entidad primero",
    "aiQuerySuccess": "¡Consulta de IA generada y ejecutada exitosamente!",
    "aiQueryWarning": "Consulta de IA generada pero la ejecución falló. Por favor revisa y ejecuta manualmente.",
    "aiQueryFailed": "Consulta de IA Falló",
    "aiQueryFailedDetail": "Error al generar consulta desde el prompt. Por favor intenta de nuevo o proporciona detalles más específicos.",
    "queryConfigNotFound": "Configuración de consulta no encontrada",
    "queryLoaded": "¡Consulta \"{queryName}\" cargada en el Constructor de Consultas!",
    "failedToLoadQuery": "Error al cargar la consulta guardada",
    "noQueryToSaveReport": "No hay consulta para guardar. Por favor ejecuta una consulta primero.",
    "noQueryToSaveQuery": "No hay consulta para guardar. Por favor ejecuta una consulta primero.",
    "reportSavedSuccessfully": "¡Reporte guardado exitosamente!",
    "failedToSaveReport": "Error al guardar el reporte",
    "querySavedSuccessfully": "¡Consulta guardada exitosamente!",
    "failedToSaveQuery": "Error al guardar la consulta"
  },
  "insightCard": {
    "title": "Análisis de Datos con IA",
    "poweredBy": "Impulsado por inteligencia artificial de Bono",
    "aiGenerated": "Generado por IA",
    "keyFindings": "Hallazgos Clave",
    "regenerate": "Regenerar",
    "analyzingData": "La IA está analizando tus datos",
    "generatingInsights": "Generando análisis inteligentes..."
  },
  "activityLog": {
    "title": "Registro de Actividad",
    "subtitle": "Monitorea y rastrea todas las actividades en tu organización",
    "activityFeed": "Feed de Actividad",
    "summary": "Resumen",
    "detailed": "Detallado",
    "noEvents": "No se encontraron eventos de actividad",
    "loading": "Cargando eventos de actividad...",
    "loadMore": "Cargar más",
    "filters": {
      "dateRange": "Rango de Fechas",
      "domain": "Dominio",
      "visibilityLevel": "Nivel de Visibilidad",
      "search": "Buscar"
    }
  },
  "BULK_UPLOAD": {
    "configurator": {
      "title": "Configurar Carga Masiva",
      "description": "Añade múltiples configuraciones de fuentes de emisión para generar una plantilla CSV completa",
      "emissionGroup": "Grupo de Emisión",
      "emissionSource": "Fuente de Emisión",
      "unit": "Unidad",
      "period": "Período",
      "facilities": "Instalaciones",
      "addToList": "Añadir a la Lista",
      "clear": "Limpiar",
      "addedConfigurations": "Configuraciones Añadidas ({count})",
      "rows": "Filas",
      "actions": "Acciones",
      "facilityCount": "{count} instalación | {count} instalaciones",
      "totalSummary": "Total: {rows} filas en {configurations} configuraciones se generarán",
      "emptyState": "Aún no se han añadido configuraciones",
      "emptyStateHint": "Completa el formulario arriba y haz clic en 'Añadir a la Lista' para comenzar a construir tu plantilla CSV",
      "remove": "Eliminar",
      "generateCSV": "Generar y Descargar CSV",
      "generateExcel": "Generar y Descargar Excel",
      "downloadSuccess": "Archivo Excel generado exitosamente",
      "downloadError": "Error al generar el archivo Excel. Por favor, inténtelo de nuevo.",
      "cancel": "Cancelar",
      "fileName": "huella_carbono_carga_masiva",
      "periodTypes": {
        "ANNUAL": "Anual (1x)",
        "MONTHLY": "Mensual (12x)",
        "CUSTOM": "Personalizado (1x)"
      },
      "selectPlaceholder": "Seleccionar",
      "required": "Requerido",
      "hgvType": "Tipo de HGV",
      "vanType": "Tipo de Furgoneta",
      "liveStockType": "Tipo de Ganado",
      "temperatureType": "Temperatura (°C)",
      "manureManagement": "Gestión de Estiércol del Ganado"
    },
    "hgvTypes": {
      "unknown": "Desconocido",
      "rigid_3_5_7_5": "Rígido (>3.5 - 7.5 toneladas)",
      "rigid_7_5_17": "Rígido (>7.5 toneladas-17 toneladas)",
      "rigid_17_plus": "Rígido (>17 toneladas)",
      "all_rigids": "Todos los rígidos",
      "articulated_3_5_33": "Articulado (>3.5 - 33t)",
      "articulated_33_plus": "Articulado (>33t)",
      "all_artics": "Todos los articulados",
      "all_hgvs": "Todos los HGVs"
    },
    "vanTypes": {
      "unknown": "Desconocido",
      "class_1": "Clase I (hasta 1.305 toneladas)",
      "class_2": "Clase II (1.305 a 1.74 toneladas)",
      "class_3": "Clase III (1.74 a 3.5 toneladas)"
    },
    "livestockTypes": {
      "Alpacas": "alpacas",
      "Buffalo": "búfalos",
      "Camels": "camellos",
      "Cattle": "ganado bovino",
      "Chicken": "pollos",
      "Deer": "ciervos",
      "Goats": "cabras",
      "Horses": "caballos",
      "Pigs": "cerdos",
      "Sheep": "ovejas"
    },
    "fieldComments": {
      "activityData": "Ingrese el peso de la carga en toneladas",
      "activityDataPassengers": "Ingrese el número de pasajeros",
      "distance": "Ingrese en kilómetros",
      "fromName": "Ingrese el nombre del origen",
      "toName": "Ingrese el nombre del destino",
      "ladenPercentage": "Ingrese el porcentaje de carga sin el símbolo %"
    },
    "fileUpload": {
      "configuratorHeader": "Configurar Carga Masiva",
      "referenceGuideTitle": "Guía de Referencia de Plantilla CSV",
      "importantNotice": "¡Tu plantilla de Excel está lista!",
      "referenceGuideDescription": "La plantilla incluye hojas preconfiguradas, listas desplegables y comentarios útiles. Revisa los comentarios en la fila de encabezado para saber qué ingresar en cada campo. En la pestaña Anexo, encontrarás filas de ejemplo y opciones válidas para cada campo. Cuando termines, completa tus datos de actividad y sube el archivo. ¿Resumen rápido? Revisa las tarjetas de abajo con lo que debes ingresar.",
      "configureDownload": "Configurar y Descargar Archivo",
      "downloadCSV": "Descargar CSV",
      "searchPlaceholder": "Buscar campos por nombre, descripción o tipo...",
      "searchResults": "{count} campo encontrado | {count} campos encontrados",
      "noFieldsFound": "No se encontraron campos",
      "tryDifferentKeywords": "Intenta buscar con palabras clave diferentes",
      "description": "Descripción",
      "type": "Tipo",
      "validValues": "Valores Válidos",
      "required": "Requerido",
      "optional": "Opcional",
      "fieldTypes": {
        "number": "Número (decimal)",
        "text": "Texto",
        "integer": "Número entero",
        "selection": "Selección de lista",
        "yesNo": "Sí/No",
        "date": "Fecha",
        "dateTime": "Fecha y hora"
      },
      "uploadGuide": "Guía de Carga",
      "uploadFile": "Subir Archivo",
      "noUploadHistory": "Aún no hay historial de cargas",
      "getStarted": "Comienza configurando y descargando tu plantilla Excel",
      "configureTemplate": "Configurar y Descargar Plantilla",
      "fileName": "Nombre del Archivo",
      "fileSize": "Tamaño del Archivo",
      "uploadDate": "Fecha de Carga",
      "status": "Estado",
      "createdBy": "Creado Por",
      "actions": "Acciones",
      "expand": "Expandir",
      "collapse": "Contraer",
      "lineNumber": "Línea #",
      "sendCorrections": "Enviar Correcciones",
      "processWithErrors": "Procesar con Errores",
      "cancel": "Cancelar",
      "startUpload": "Iniciar carga",
      "selectFile": "Seleccionar Archivo",
      "correctData": "Corrige los Datos",
      "viewRows": "Ver filas",
      "close": "Cerrar",
      "delete": "Eliminar",
      "deleteConfirm": "¿Está seguro de que desea eliminar esta solicitud de proceso de archivo?",
      "deleteSuccess": "Solicitud de proceso de archivo eliminada exitosamente",
      "deleteError": "Error al eliminar la solicitud de proceso de archivo",
      "fileSizeExceeded": "El tamaño del archivo excede el máximo permitido de {size}. Por favor seleccione un archivo más pequeño.",
      "downloadFile": "Descargar Archivo",
      "summary": "Resumen",
      "rowDetails": "Detalles de Filas",
      "validRows": "Filas Válidas",
      "invalidRows": "Filas Inválidas",
      "processedRows": "Filas Procesadas",
      "notProcessedRows": "No Procesadas",
      "totalRows": "Total de Filas",
      "rowsPerPage": "Filas por página",
      "showingRecords": "Mostrando {first} a {last} de {total} registros",
      "filterByStatus": "Filtrar por estado",
      "selectStatus": "Seleccionar estado...",
      "totalRecords": "{count} registros",
      "lineStatusFilter": {
        "valid": "Válido",
        "notValid": "No Válido",
        "processed": "Procesado",
        "notProcessed": "No Procesado"
      },
      "toasts": {
        "selectFileWarning": "Por favor seleccione un archivo antes de subir.",
        "uploadSuccess": "¡Archivo subido exitosamente!",
        "uploadError": "Error al subir el archivo.",
        "correctAllLines": "Corregir Todas las Líneas",
        "notAllCorrected": "No todos los campos con error están corregidos. Por favor corrija todos los campos antes de enviar.",
        "correctionsSuccess": "¡Correcciones enviadas exitosamente!",
        "correctionsError": "Ocurrió un error al enviar las correcciones.",
        "success": "Éxito",
        "error": "Error",
        "warning": "Advertencia",
        "uploadFailed": "Carga Fallida"
      }
    }
  },
  "password": {
    "title": "Cambiar contraseña",
    "newPassword": "Nueva contraseña",
    "newPasswordPlaceholder": "Ingrese su nueva contraseña",
    "confirmPassword": "Confirmar nueva contraseña",
    "confirmPasswordPlaceholder": "Confirme su nueva contraseña",
    "changeButton": "Cambiar contraseña",
    "requirements": {
      "title": "Requisitos de contraseña",
      "minLength": "Al menos 8 caracteres",
      "uppercase": "Al menos 1 letra mayúscula",
      "lowercase": "Al menos 1 letra minúscula",
      "number": "Al menos 1 número",
      "special": "Al menos 1 carácter especial"
    },
    "success": "Su contraseña ha sido cambiada exitosamente",
    "errors": {
      "mismatch": "Las contraseñas no coinciden",
      "sameAsPrevious": "Su nueva contraseña no puede ser igual a su contraseña anterior",
      "failed": "Error al cambiar la contraseña. Por favor, inténtelo de nuevo."
    }
  },
  "toasts": {
    "success": {
      "saved": "Guardado exitosamente",
      "updated": "Actualizado exitosamente",
      "deleted": "Eliminado exitosamente",
      "created": "Creado exitosamente",
      "submitted": "Enviado exitosamente",
      "approved": "Aprobado exitosamente",
      "rejected": "Rechazado exitosamente"
    },
    "error": {
      "saveFailed": "Error al guardar. Por favor, inténtelo de nuevo.",
      "updateFailed": "Error al actualizar. Por favor, inténtelo de nuevo.",
      "deleteFailed": "Error al eliminar. Por favor, inténtelo de nuevo.",
      "createFailed": "Error al crear. Por favor, inténtelo de nuevo.",
      "submitFailed": "Error al enviar. Por favor, inténtelo de nuevo.",
      "loadFailed": "Error al cargar datos. Por favor, inténtelo de nuevo."
    },
    "warning": {
      "unsavedChanges": "Tiene cambios sin guardar",
      "requiredFields": "Por favor, complete todos los campos requeridos"
    },
    "info": {
      "noChanges": "No hay cambios para guardar"
    }
  },
  "validation": {
    "required": "Este campo es requerido",
    "email": "Por favor, ingrese un correo electrónico válido",
    "minLength": "Debe tener al menos {min} caracteres",
    "maxLength": "Debe tener como máximo {max} caracteres",
    "passwordMismatch": "Las contraseñas no coinciden",
    "invalidFormat": "Formato inválido"
  },
  "common": {
    "save": "Guardar",
    "cancel": "Cancelar",
    "submit": "Enviar",
    "edit": "Editar",
    "delete": "Eliminar",
    "close": "Cerrar",
    "confirm": "Confirmar",
    "loading": "Cargando...",
    "search": "Buscar",
    "filter": "Filtrar",
    "all": "Todos",
    "none": "Ninguno",
    "yes": "Sí",
    "no": "No",
    "ok": "Aceptar",
    "back": "Atrás",
    "next": "Siguiente",
    "previous": "Anterior",
    "finish": "Finalizar",
    "noData": "No hay datos disponibles",
    "required": "Requerido",
    "optional": "Opcional",
    "actions": "Acciones",
    "status": "Estado",
    "date": "Fecha",
    "name": "Nombre",
    "description": "Descripción",
    "type": "Tipo",
    "select": "Seleccionar",
    "selectAll": "Seleccionar todo",
    "deselectAll": "Deseleccionar todo",
    "clearAll": "Limpiar todo",
    "showMore": "Ver más",
    "showLess": "Ver menos",
    "viewAll": "Ver todo",
    "environmental": "Ambiental",
    "social": "Social",
    "governance": "Gobernanza",
    "completed": "Completado",
    "inReview": "En Revisión",
    "pending": "Pendiente",
    "approved": "Aprobado",
    "email": "Correo electrónico",
    "firstName": "Nombre",
    "lastName": "Apellido",
    "role": "Rol",
    "readOnly": "Solo lectura",
    "noRole": "Sin rol",
    "indicators": "indicadores"
  }
}
